import type { UUID } from '@cmg/common';
import { useCallback } from 'react';

import type { CrmManagement_FirmsInvestorContactsGridQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_AdminFirmsInvestorContactsGridLazyQuery,
  useCrmManagement_FirmsInvestorContactsGridLazyQuery,
} from '../graphql/__generated__';

export function useFirmsInvestorContactsGridQuery(tenantId?: UUID) {
  const [loadRowsAsCustomer] = useCrmManagement_FirmsInvestorContactsGridLazyQuery();
  const [loadRowsAsAdmin] = useCrmManagement_AdminFirmsInvestorContactsGridLazyQuery();

  return useCallback(
    async (variables: CrmManagement_FirmsInvestorContactsGridQueryVariables) => {
      if (tenantId) {
        const response = await loadRowsAsAdmin({
          variables: {
            ...variables,
            tenantId,
          },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            investorFirmsGrid: response.data?.adminInvestorFirmsGrid,
          },
        };
      } else {
        return await loadRowsAsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [tenantId, loadRowsAsAdmin, loadRowsAsCustomer]
  );
}
